export const getSubdomain = () => window.location.host.split('.')[0];
